"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelationAutoSuggest = exports.Relations = void 0;
var React = require("react");
var inputComponents_1 = require("./inputComponents");
var combobox_1 = require("../lib/combobox");
var mobx_react_1 = require("mobx-react");
var Relations = (function (_super) {
    __extends(Relations, _super);
    function Relations() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.changeHandler = function (event) {
            _this.props.onChangeHandler(event.currentTarget.value, event.currentTarget.checked);
        };
        return _this;
    }
    Relations.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "Relations" },
            this.props.relations.map(function (relation) { return (React.createElement("div", null,
                React.createElement(inputComponents_1.Checkbox3, { value: relation.id.toString(), checked: relation.checked, indeterminate: relation.indeterminate, onChange: _this.changeHandler, labelText: relation.display, suggestion: relation.display, maxTextLength: 100 }))); }),
            React.createElement("div", null,
                React.createElement(RelationAutoSuggest, { objects: this.props.objects, onChange: function (id) { return _this.props.addRelationHandler(id); }, focusInputOnSuggestionClick: false }))));
    };
    Relations = __decorate([
        mobx_react_1.observer
    ], Relations);
    return Relations;
}(React.Component));
exports.Relations = Relations;
exports.default = Relations;
var RelationAutoSuggest = (function (_super) {
    __extends(RelationAutoSuggest, _super);
    function RelationAutoSuggest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RelationAutoSuggest.prototype.objectToSuggestion = function (relation) {
        return {
            value: relation.id.toString(),
            label: relation.display,
            suggestionLabel: "".concat(relation.display),
        };
    };
    RelationAutoSuggest.prototype.render = function () {
        var props = this.props;
        return (React.createElement(combobox_1.ObjectSuggest, { objects: props.objects, defaultOptionText: props.defaultOptionText, onChange: props.onChange, onBlur: props.onBlur, selected: props.selected, autofocus: props.autofocus, objectToSuggestion: this.objectToSuggestion, focusInputOnSuggestionClick: this.props.focusInputOnSuggestionClick }));
    };
    RelationAutoSuggest = __decorate([
        mobx_react_1.observer
    ], RelationAutoSuggest);
    return RelationAutoSuggest;
}(React.Component));
exports.RelationAutoSuggest = RelationAutoSuggest;
